/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Calendar/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import Tysiav2CalendarIcon from 'DesignSystem/Svgs/Tysiav2CalendarIcon/index'



/** @type {import('Simple/types.js').View} */
export default function Calendar({
  children,
  viewPath = "/App/Account/Topbar/Tabs/QuickAccess/Tab/Icon/Calendar",
  hovered,
  selected
  
}) {
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
  return (<React.Fragment
>
<Tysiav2CalendarIcon
  viewPath={`${viewPath}/Tysiav2CalendarIcon`}
 width={16}
 height={16}
 fill2={hovered && selected ? dtColorsWhite : hovered ? dtColorsWhite : selected ? dtColorsWhite : dtColorsWhite}
/>
{children}
</React.Fragment>)
}